import React, { Component } from "react";
import { Table, Button } from "antd";
import { columns, handleMoneyValue } from "./data-table";
import { driverlessPRColumns } from "../journey-detail/driverless/table-data-driverless-pr";
import { TotalRow } from "../journey-detail/total-row";
import { apiPaymentRequest } from "../../../../api/api-payment-request";
import { emitter } from "../../../../common/utils/emitter";
import { alert } from "../../../../common/utils/alert";
import moment from "moment";
import { apiJourney } from "../../../../api/api-journey";

const paymentRequestColumns = [
  {
    title: "",
    dataIndex: "name",
    key: "name",
    className: "column-200 td-left",
  },
  {
    title: "Đơn giá",
    dataIndex: "price",
    key: "price",
    className: "column-80",
    render: (price) => (
      <span>{price === 0 ? "-" : handleMoneyValue(price)}</span>
    ),
  },
  {
    title: "Số lượng",
    dataIndex: "count",
    key: "count",
    className: "column-80",
    render: (count) => <span>{count === 0 ? "-" : count}</span>,
  },
  {
    title: "Đơn vị",
    dataIndex: "unit",
    key: "unit",
    className: "column-80",
  },
  {
    title: "Thành tiền",
    dataIndex: "total_price",
    key: "total_price",
    className: "column-80",
    render: (price, record) => (
      <span>
        {record.count !== null
          ? price === 0
            ? "-"
            : handleMoneyValue(price)
          : price === 0
          ? "0"
          : handleMoneyValue(price)}
      </span>
    ),
  },
];
export class PaymentRequest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      payment_data: [],
      loading: false,
      xScroll: window.innerHeight <= 800 ? 400 : window.innerHeight - 450,
      total: {
        over_km: 0,
      },
      usersSelected: [],
    };
  }

  async componentDidMount() {
    const { contractData, date, totalForPaymentRequest } = this.props;

    apiJourney
      .fetchSuggestCustomer({ contract_id: contractData.id })
      .then((res) => {
        if (res.status === "success" && this.props.member_customer_ids) {
          const idsCustomer = this.props.member_customer_ids.split(",");

          const usersSelected = idsCustomer.map((item) =>
            res.data.find((i) => Number(i.id) === Number(item))
          );
          this.setState({ usersSelected });
        }
      });

    window.addEventListener("resize", () => {
      if (window.innerHeight <= 800) {
        this.setState({ xScroll: 400 });
      } else {
        this.setState({ xScroll: window.innerHeight - 500 });
      }
    });

    if (contractData.contract_type.id === 1) {
      try {
        this.setState({ loading: true });
        const result = await apiPaymentRequest.getPaymentRequest({
          contract_id: contractData.id,
          from: date.start,
          to: date.end,
          member_customer_ids: this.props.member_customer_ids,
        });
        this.setState({ loading: false });
        if (result.status === "success") {
          this.setState({ payment_data: result.data });
        }
      } catch (error) {
        this.setState({ loading: false });
      }
    } else {
      try {
        this.setState({ loading: true });
        const result = await apiPaymentRequest.getPaymentRequestDriverless({
          contract_id: contractData.id,
          from: date.start,
          to: date.end,
          member_customer_ids: this.props.member_customer_ids,
        });
        this.setState({ loading: false });
        if (result.status === "success") {
          const dataConvert = result.data.diaries.map((value, index) => {
            return {
              index: index + 1,
              ...value,
            };
          });
          this.setState({
            payment_data: result.data.payment_request,
            journey_diarys_driverless: dataConvert.slice(
              0,
              result.data.diaries.length - 1
            ),
            total: {
              over_km: result.data.diaries[result.data.diaries.length - 1]
                .over_km
                ? result.data.diaries[result.data.diaries.length - 1].over_km
                : 0,
              // km_traveled: result.data.diaries[result.data.diaries.length - 1].used_km,
            },
          });
        }
      } catch (error) {
        this.setState({ loading: false });
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", () => {});
  }

  handleExportPaymentRequest = async () => {
    try {
      const { contractData, date } = this.props;
      const filter = {
        contract_id: contractData.id,
        from: date.start,
        to: date.end,
        member_customer_ids: this.props.member_customer_ids,
      };
      emitter.emit("FETCH_LOADING", true);
      if (contractData.contract_type.id === 1) {
        apiPaymentRequest.exportPaymentRequest(filter).then((res) => {
          if (res === "success") {
            alert("success", "Export thành công");
            emitter.emit("FETCH_LOADING", false);
          } else {
            alert("error", "Không export thành công");
            emitter.emit("FETCH_LOADING", false);
          }
        });
      } else {
        apiPaymentRequest.exportPaymentRequestDriverless(filter).then((res) => {
          if (res === "success") {
            alert("success", "Export thành công");
            emitter.emit("FETCH_LOADING", false);
          } else {
            alert("error", "Không export thành công");
            emitter.emit("FETCH_LOADING", false);
          }
        });
      }
    } catch (error) {
      alert("error", "Không export thành công");
      emitter.emit("FETCH_LOADING", false);
    }
  };

  handleSentToCustomer = async () => {
    try {
      const { contractData, date } = this.props;
      const filter = {
        contract_id: contractData.id,
        from: date.start,
        to: date.end,
        member_customer_ids: this.props.member_customer_ids,
      };
      emitter.emit("FETCH_LOADING", true);
      apiPaymentRequest.sentPaymentRequestToCustomer(filter).then((res) => {
        if (res.status === "success") {
          alert("success", "Gửi tới khách hàng thành công");
          emitter.emit("FETCH_LOADING", false);
        } else {
          alert("error", "Không gửi thành công");
          emitter.emit("FETCH_LOADING", false);
        }
      });
    } catch (error) {
      alert("error", "Không gửi thành công");
      emitter.emit("FETCH_LOADING", false);
    }
  };

  render() {
    const {
      payment_data,
      loading,
      xScroll,
      journey_diarys_driverless,
      usersSelected,
    } = this.state;
    const { journey_diarys, contractData, date, totalForPaymentRequest } =
      this.props;
    const { customer, member_customer, vehicle, driver } = contractData;
    return (
      <div className="journey-diary payment-request">
        <div className="title-container">
          <div className="title-payment">AVIS CAR LICENSE</div>
          <div className="title-payment">
            AN HOA PHAT RENT A CAR COMPANY LIMITED
          </div>
          <div className="title-payment">
            5th Floor - 11 Pham Hung Street - My Dinh 2 Ward- Nam Tu Liem Dist -
            Ha Noi - Viet Nam
          </div>
          <div className="title-payment">
            Brand Ho Chi Minh, No. 27, 06 Street, Quarter 5, Hiep Binh Chanh
            Ward, Thu Duc City, Ho Chi Minh City, Vietnam.
          </div>
          <img
            className="payment-request-logo"
            src={require("../../../../assets/images/payment-request-logo.png")}
          />
        </div>
        <div className="info-container">
          <div className="text">
            Tên khách hàng: {customer ? customer.name : ""}
          </div>
          <div className="text">
            Admin: {member_customer ? member_customer.name : ""}
          </div>
          <div className="text">
            User: {usersSelected.map((i) => i.name).join(", ")}
          </div>
          <div className="text">Địa chỉ: {customer.address}</div>
          <div className="text">
            Từ ngày: {moment(date.start).format("DD/MM/YYYY")} đến ngày{" "}
            {moment(date.end).format("DD/MM/YYYY")}
          </div>
          <div className="text">Tài xế: {driver ? driver.name : ""}</div>
          <div className="text">
            Biển KS: {vehicle ? vehicle.number_plate : ""}
          </div>
        </div>
        <Table
          className="diary-table"
          style={{ width: "100%" }}
          scroll={{ x: true, y: xScroll, scrollToFirstRowOnChange: true }}
          columns={
            contractData.contract_type.id === 1
              ? columns(this)
              : driverlessPRColumns(this)
          }
          bordered
          loading={contractData.contract_type.id === 2 && loading}
          summary={(pageData) => {
            return (
              <TotalRow
                total={totalForPaymentRequest}
                is_payment_request
                isDriverLess={
                  contractData.contract_type.id === 1 ? false : true
                }
                pageData={pageData}
              />
            );
          }}
          pagination={false}
          dataSource={
            contractData.contract_type.id === 1
              ? journey_diarys.map((value) => {
                  return {
                    ...value,
                    children: undefined,
                  };
                })
              : journey_diarys_driverless
          }
        />
        <div className="payment-request-fee">
          <Table
            className="payment-request-table"
            style={{ width: "100%" }}
            loading={loading}
            //scroll={{ x: true, scrollToFirstRowOnChange: true }}
            columns={paymentRequestColumns}
            bordered
            pagination={false}
            dataSource={payment_data}
          />
          <div className="button-container ">
            <Button
              onClick={this.handleSentToCustomer}
              className="add-btn payment-button"
            >
              Gửi đến KH
            </Button>
            <Button
              onClick={this.handleExportPaymentRequest}
              className="add-btn payment-button export"
            >
              Export
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
